interface Storage {
  get: <T = unknown>(key: string, defaultValue?: T) => T;
  set: <T = unknown>(key: string, value: T) => void;
  remove: (key: string) => void;
}

export function storageFactory(storageType: 'sessionStorage' | 'localStorage'): Storage {
  const webStorage = window[storageType];

  return {
    /**
     * Get a value.
     *
     * Deserialize the JSON object back to its original type.
     *
     * @param key Key to get.
     * @param defaultValue [optional] Default value to return in case the key is not found.
     * @returns {*}
     */
    get: (key, defaultValue) => {
      const value = webStorage.getItem(key);

      if (value === null) {
        return typeof defaultValue !== 'undefined' ? defaultValue : value;
      }
      try {
        return JSON.parse(value);
      } catch (e) {
        return defaultValue;
      }
    },

    /**
     * Set a value.
     *
     * Serialize the object to JSON, so we can store any kind of value.
     *
     * @param key Key to set.
     * @param value Value to set.
     */
    set: (key, value) => {
      webStorage.setItem(key, JSON.stringify(value));
    },

    /**
     * Remove an item.
     *
     * @param key Key to remove.
     */
    remove: (key) => {
      webStorage.removeItem(key);
    },
  };
}

export const SessionStorage = storageFactory('sessionStorage');

export const LocalStorage = storageFactory('localStorage');
